import { createCrudPage } from './factories/crud-page.js';

/**
 * Legacy backend reads `id` as a query param; not part of shared AppContext.
 * @typedef {import('../contracts/context.js').AppContext & { id?: string | number }} LegacyFeaturedContext
 */

export default createCrudPage({
  title: 'Featured',
  basePath: '/featured',
  defaultSort: { field: 'start_date', dir: 'desc' },
  columns: [
    { key: 'client_name', label: 'Client', sortable: true },
    { key: 'company_name', label: 'Brand', sortable: true },
    { key: 'premium', label: 'Premium',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'start_date', label: 'Start', sortable: true },
    { key: 'end_date', label: 'End', sortable: true },
    { key: 'clicks', label: 'Clicks', sortable: true },
  ],
  fields: [
    { key: 'clients_pid', label: 'Client', type: 'async-select',
      optionsUrl: '/clients/options' },
    { key: 'company_id', label: 'Brand', type: 'async-select',
      optionsUrl: '/companies/options',
      dependsOn: ['clients_pid'], visible: (v) => !!v.clients_pid },
    { key: 'premium', label: 'Premium', type: 'yesno', defaultValue: '0' },
    { key: 'start_date', label: 'Start', type: 'datetime' },
    { key: 'end_date', label: 'End', type: 'datetime' },
  ],
  filters: [
    { key: 'archive', label: 'Archive', type: 'radio',
      options: [
        { value: '', label: 'Active' },
        { value: '1', label: 'Archived' },
      ] },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit',
      visible: (row) => row.archive == 0 },
    { key: 'archive', label: 'Archive', variant: 'danger', icon: 'lock',
      confirm: 'Are you sure you want to archive it? Note, there is no undo.',
      visible: (row) => row.appearance != 0 && row.archive == 0 },
    { key: 'duplicate', label: 'Duplicate', icon: 'clone',
      visible: (row) => row.archive != 0 },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?',
      visible: (row) => row.appearance == 0 },
  ],
  fetchParams: (ctx) => {
    const legacy = /** @type {LegacyFeaturedContext} */ (ctx.services.context);
    return {
      id: legacy.id,
      country: legacy.country,
    };
  },
  customActions: (ctx) => ({
    archive: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `/featured/${encodeURIComponent(id)}`, { archive: 1 }, { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    duplicate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      const data = await ctx.adapter.get(id);
      const { id: _id, archive: _archive, start_date: _start_date, end_date: _end_date, appearance: _appearance, clicks: _clicks, ...rest } = data;
      ctx.editor.open(undefined, { prefill: rest });
    },
  }),
});
